import styled from 'styled-components';
import { tokens } from '@companycam/slab';
import { Button } from '@companycam/slab-web';

export const AddSectionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 32px auto;
`;

export const AddSectionButton = styled(Button)`
  width: 100%;
  justify-content: flex-start;
  border-style: dashed;
  border-color: var(--cc_color_border_default);

  &:hover {
    border-color: var(--cc_color_border_input_inactive);
  }
`;

export const SectionTitleInput = styled.input`
  font-family: 'Averta', system-ui, sans-serif;
  font-size: ${tokens.size_text_m + 1}px;
  font-weight: 600;
  border: none;
  background-color: transparent;
  text-overflow: ellipsis;
`;

export const SectionTitle = styled.h3`
  font-family: 'Averta', system-ui, sans-serif;
  font-size: ${tokens.size_text_m + 1}px;
  font-weight: 600;
  background-color: var(--cc_color_background_3);
  width: 100%;
  border-radius: ${tokens.size_border_radius_l}px;
  padding: ${tokens.size_spacing_m}px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 52px;
  display: flex;
  justify-content: space-between;
`;
